import React from "react";
import SignupContainer from "app/pages/Auth/Signup/SignupContainer";
import LoginContainer from "app/pages/Auth/Signin/LoginContainer";
import { useHistory } from "react-router-dom";
import { parseQueries } from "app/utils/routerUtils";
import { FormattedMessage } from "react-intl";
import PropTypes from "prop-types";
import "./AuthBookingLayer.scss";
import IconBack from "app/pages/.shared/static/icons/IconBack";
import RelativeLink from "app/pages/.shared/RelativeLink";

const AuthBookingLayer = ({ brandDisplayName }) => {
	const history = useHistory();

	const onAuthSuccess = React.useCallback(() => {
		const query = parseQueries(location.search);
		if (query.onauthsuccess) {
			history.replace(query.onauthsuccess);
		} else {
			history.push("/");
		}
	}, [history]);

	const [showSignIn, setShowSignIn] = React.useState(false);

	const onClickShowsignIn = React.useCallback(() => {
		setShowSignIn(false);
	}, []);

	const onClickShowSignUp = React.useCallback(() => {
		setShowSignIn(true);
	}, []);

	const authFooter = (
		<div className="auth-booking-layer__footer">
			<FormattedMessage
				id={showSignIn ? "booking.auth.signin.footer" : "booking.auth.signup.footer"}
				values={{
					// eslint-disable-next-line react/no-multi-comp
					span: chunks => (
						<RelativeLink
							className="nav__item-link"
							to={{ pathname: "/booking-search" }}
						>
							<span>{chunks}</span>
						</RelativeLink>
					),
				}}
			/>
		</div>
	);

	return (
		<div className="auth-booking-layer" data-cy="auth-layer">
			<div className="auth-booking-layer__header">
				<div
					className="auth-booking-layer__header-back"
					onClick={() => {
						window.history.back();
					}}
				>
					<IconBack />
				</div>
				<div className="auth-booking-layer__header-title">
					<FormattedMessage
						id={showSignIn ? "home.signin.button.label" : "home.signup.button.label"}
					/>
				</div>
				<div className="auth-booking-layer__header-right" />
			</div>
			<div className="auth-booking-layer__auth-form">
				{showSignIn ? (
					<LoginContainer
						headline={
							<FormattedMessage
								id="booking.signin.headline"
								values={{ brandDisplayName }}
							/>
						}
						footer={authFooter}
						onAuthSuccess={onAuthSuccess}
						onToogleSignupForm={onClickShowsignIn}
					/>
				) : (
					<SignupContainer
						headline={
							<React.Fragment>
								<FormattedMessage
									id="booking.signup.headline"
									values={{ brandDisplayName }}
								/>
								<div className="auth__headline--small">
									<FormattedMessage
										id="booking.signup.headline2"
										values={{ brandDisplayName }}
									/>
								</div>
							</React.Fragment>
						}
						footer={authFooter}
						onAuthSuccess={onAuthSuccess}
						onToogleSigninForm={onClickShowSignUp}
					/>
				)}
			</div>
		</div>
	);
};

AuthBookingLayer.propTypes = {
	brandDisplayName: PropTypes.string,
};

export default AuthBookingLayer;
